/* Livora London: Fashion Gallery Slider — autoplay + seamless infinite loop + full manual swipe,
   via a native horizontally-scrollable track rather than a CSS keyframe animation. Autoplay nudges
   scrollLeft forward at a constant speed; whenever scrollLeft crosses into the first or last of
   the four identical, back-to-back groups rendered by the section, it's silently shifted by
   exactly one group's width — since every group is pixel-identical, that shift is invisible,
   giving a seamless loop regardless of whether the motion came from autoplay or a swipe. No
   external library. */
(function () {
  if (window.lvFashionGallerySliderLoaded) return;
  window.lvFashionGallerySliderLoaded = true;

  function initOne(root) {
    if (root.dataset.lvFgInit) return;
    root.dataset.lvFgInit = 'true';

    var track = root.querySelector('[data-lv-fg-track]');
    if (!track) return;

    var speed = parseFloat(root.dataset.speed) || 60; // px per second
    var autoplayWanted = root.dataset.autoplay === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = autoplayWanted && !reduceMotion;

    var groupWidth = 0;
    function measure() {
      // .lv-fg__group is `display: contents` (so items lay out as direct flex children
      // of the track, where their percentage widths actually resolve) and so has no box
      // of its own to measure. The track always renders exactly 4 identical groups.
      var newWidth = track.scrollWidth / 4;
      var hadNoWidth = groupWidth === 0;
      groupWidth = newWidth;
      // Start positioned at the start of the second copy, so there's always a full group's worth
      // of room to wrap in either direction (forward autoplay, or a manual swipe backward).
      if (hadNoWidth && groupWidth > 0) track.scrollLeft = groupWidth;
    }
    measure();
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(track);

    var paused = !autoplay;
    var resumeTimer = null;

    function pause() {
      paused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
    }
    function scheduleResume() {
      if (!autoplay) return;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        paused = false;
      }, 1500);
    }

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, pause, { passive: true });
    });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel', 'mouseleave'].forEach(function (evt) {
      track.addEventListener(evt, scheduleResume, { passive: true });
    });

    // Seamless wrap: keep scrollLeft inside the middle two groups' range at all times.
    track.addEventListener(
      'scroll',
      function () {
        if (groupWidth <= 0) return;
        if (track.scrollLeft >= groupWidth * 2) {
          track.scrollLeft -= groupWidth;
        } else if (track.scrollLeft < groupWidth * 0.5) {
          track.scrollLeft += groupWidth;
        }
      },
      { passive: true }
    );

    if (!autoplay) return;

    var last = null;
    function frame(ts) {
      if (last === null) last = ts;
      var dt = (ts - last) / 1000;
      last = ts;
      if (!paused && groupWidth > 0) {
        track.scrollLeft += speed * dt;
      }
      root.lvFgRaf = requestAnimationFrame(frame);
    }
    root.lvFgRaf = requestAnimationFrame(frame);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lv-fg]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-init a freshly re-rendered section instance.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
